// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"87620d5f","557":"38b43eeb","787":"013bcbf1"}[chunkId] + ".chunk.js";
};